import { ICalculatorInput } from "../../models/ICalculatorInput";
import IPrintingConfiguration from "../../models/IPricingConfiguration";
import { Mode } from "../ModeUtils";

export default function filterColourModes(
  calculatorInput: ICalculatorInput,
  printingConfiguration: IPrintingConfiguration,
) {
  const printingOption = printingConfiguration.printingOptions.filter(
    (po) => po.code === calculatorInput.selectedPrintingOption,
  )[0];

  let mixModeAvailable = printingOption.supportsMixMode;

  if (
    printingOption.requireMultiplesOfFour ||
    printingOption.requireDuplexMode
  ) {
    mixModeAvailable = mixModeAvailable && true;
  } else {
    mixModeAvailable = mixModeAvailable && !calculatorInput.isDuplexSelected;
  }

  return Mode.filter(
    (m) =>
      (mixModeAvailable &&
        (calculatorInput.pagesBlack ?? 0) + (calculatorInput.pagesColour ?? 0) >
          1) ||
      m.code !== "mix",
  );
}
